export const primaryColor = '#2F1160'